import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {TrackingRecoElement} from '@aboutyou/legacy-tracking-sdk';
import {CTAWishButton as SquareWishButton} from '@aboutyou/ui-components';
import React, {ComponentProps, FC} from 'react';
import {WishlistButton} from '../../../../features/Wishlist/WishlistButton';

export function AddToWishlistButton({
  product,
  price,
  brand,
  className,
  style,
  shouldUseSquareWishButton = false,
  trackingData,
  badgesListKeys,
}: {
  product: Product;
  price?: Price;
  brand: Brand;
  className?: string;
  style?: React.CSSProperties;
  shouldUseSquareWishButton?: boolean;
  trackingData?: {
    sectionIndex?: number;
    sortingChannel?: string;
    pageType?: string;
    recoType?: string;
    elements?: TrackingRecoElement[];
  };
  badgesListKeys: string[];
}) {
  return (
    <WishlistButton
      product={product}
      price={price}
      brand={brand}
      style={style}
      className={className}
      WishlistComponent={
        shouldUseSquareWishButton ? SquareWishButton : CircleWishButton
      }
      trackingData={trackingData}
      badgesListKeys={badgesListKeys}
    />
  );
}

const CircleWishButton: FC<
  ComponentProps<typeof SquareWishButton> & {round?: boolean}
> = props => {
  return <SquareWishButton {...props} round={true} />;
};
